import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { filterNavigationItems } from 'src/app/app.navigation';
import { HelpDocumentsService } from 'src/app/util/help-documents.service';
import { UserDataService } from 'src/app/util/user-data.service';
import { LayoutService } from '../layout.service';
import {
  InventoryLink,
  NavigationItem,
  NavigationLink,
} from '../navigation/navigation-item';
import { SidenavService } from './sidenav.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit {
  @Input() collapsed: boolean;

  @Output() signOut: EventEmitter<void> = new EventEmitter<void>();

  collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;
  isDesktop$ = this.layoutService.isDesktop$;

  user = this.userDataService.user;
  navigationItems: NavigationItem[];
  inventoryItems: InventoryLink[];
  supportItems: NavigationItem[];
  upgradePlanItem: NavigationItem;

  constructor(
    private layoutService: LayoutService,
    private navigationService: SidenavService,
    private userDataService: UserDataService,
    private helpDocumentsService: HelpDocumentsService
  ) {}

  ngOnInit(): void {
    const { featureFlags, privileges } = this.userDataService;
    const { items, inventoryItems, supportItems, upgradePlanItem } = this.navigationService;
    this.navigationItems = filterNavigationItems(
      items,
      privileges,
      featureFlags
    );
    
    // Update warehouse route for users without fixed_location_tracking_session permission
    const warehouseItem = this.navigationItems.find(
      item => item.type === 'link' && item.apiLabel === 'fixed_location:plural' && 
             (item.route === '/map/warehouses/active' || item.route === '/warehouses')
    );
    if (warehouseItem && warehouseItem.type === 'link' &&
        (!privileges?.has('fixed_location_tracking_session') || 
         !privileges.get('fixed_location_tracking_session').includes('read'))) {
      if (warehouseItem.route === '/map/warehouses/active') {
        warehouseItem.route = '/map/warehouses';
      }
    }
    
    // Update trailers route when react-list-pages is enabled
    const hasReactListPages = featureFlags?.some(flag => flag.slug === 'react-list-pages' && flag.enabled);
    const trailersItem = this.navigationItems.find(
      item => item.type === 'link' && item.apiLabel === 'roving_location:plural'
    );
    if (hasReactListPages && trailersItem && trailersItem.type === 'link') {
      trailersItem.route = '/trailers';
    }
    
    this.inventoryItems = filterNavigationItems(
      inventoryItems,
      privileges,
      featureFlags
    ) as InventoryLink[];
    this.supportItems = filterNavigationItems(
      supportItems,
      privileges,
      featureFlags
    ) as NavigationItem[];
    this.loadHelpDocumentLinks(this.supportItems);
    this.upgradePlanItem = upgradePlanItem;
  }

  private loadHelpDocumentLinks(items: NavigationItem[]): void {
    for (const item of items) {
      if (item.type === 'link' && item.helpDocumentSlug) {
        const link = item as NavigationLink;
        if (
          link.requiredPlanTier &&
          !this.userDataService.planTiers?.includes(link.requiredPlanTier)
        ) {
          continue;
        }
        this.helpDocumentsService
          .getPdfUrl(link.helpDocumentSlug)
          .subscribe((pdfUrl) => {
            if (pdfUrl) {
              link.externalLink = pdfUrl;
            }
          });
      } else if (item.type === 'dropdown' && item.children?.length) {
        this.loadHelpDocumentLinks(item.children as NavigationItem[]);
      }
    }
  }

  onMouseEnter() {
    this.layoutService.collapseOpenSidenav();
  }

  onMouseLeave() {
    this.layoutService.collapseCloseSidenav();
  }

  onSignOut() {
    this.signOut.emit();
  }
  toggleCollapsed() {
    this.collapsed
      ? this.layoutService.expandSidenav()
      : this.layoutService.collapseSidenav();
  }
}
